import { ShoppingCart, Truck, Star, Package, Search, Filter } from 'lucide-react';
import { useState } from 'react';

const CATEGORIES = [
  { icon: '🥩', name: 'Thịt & Hải sản', count: 240, tag: 'Tươi sống' },
  { icon: '🥬', name: 'Rau củ quả', count: 185, tag: 'Hữu cơ' },
  { icon: '🌾', name: 'Gạo & Ngũ cốc', count: 92, tag: 'Đặc sản' },
  { icon: '🧂', name: 'Gia vị & Sauce', count: 310, tag: 'Nhập khẩu' },
  { icon: '🥛', name: 'Sữa & Dairy', count: 78, tag: 'Tươi lạnh' },
  { icon: '☕', name: 'Cà phê & Trà', count: 125, tag: 'Premium' },
  { icon: '🍷', name: 'Đồ uống & Rượu', count: 95, tag: 'Đa dạng' },
  { icon: '🧴', name: 'Dầu & Mỡ', count: 55, tag: 'Chất lượng' },
];
const SUPPLIERS = [
  { name: 'Công ty CP Thực phẩm Sạch Việt', rating: 4.8, orders: '2.4k', badge: '✓ Verified', products: 'Rau củ, thịt tươi' },
  { name: 'Hải sản Cửa Lò Premium', rating: 4.9, orders: '1.8k', badge: '⭐ Top seller', products: 'Hải sản tươi sống, đông lạnh' },
  { name: 'Cà phê Gia Lai Origin', rating: 4.7, orders: '3.1k', badge: '✓ Verified', products: 'Cà phê nhân xanh, rang xay' },
  { name: 'Gia vị Hương Việt', rating: 4.6, orders: '980', badge: '🔥 Hot', products: 'Gia vị, nước chấm, sauce' },
];

export default function DatHangNguyenLieuPage() {
  const [search, setSearch] = useState('');
  return (
    <div className="max-w-5xl mx-auto space-y-10 animate-fade-in">
      <div className="rounded-2xl overflow-hidden relative p-8 md:p-12"
           style={{ background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 50%, #60a5fa 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        <div className="relative z-10 flex items-start gap-5">
          <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
            <ShoppingCart size={32} className="text-white" />
          </div>
          <div>
            <p className="text-white/70 text-sm font-medium mb-1">Dịch vụ hỗ trợ</p>
            <h1 className="font-display font-black text-3xl text-white mb-2">Đặt hàng nguyên liệu</h1>
            <p className="text-white/80 text-base max-w-xl">
              Nền tảng B2B kết nối nhà hàng, quán cafe với nhà cung cấp nguyên liệu F&B uy tín.
              Giá tốt, giao hàng nhanh, chất lượng đảm bảo.
            </p>
            <div className="flex gap-4 mt-4 text-white/90 text-sm">
              {[['500+', 'Nhà cung cấp'], ['10,000+', 'SKU sản phẩm'], ['2h', 'Giao hàng nhanh']].map(([v, l]) => (
                <div key={l}><p className="font-black text-xl">{v}</p><p className="text-white/60 text-xs">{l}</p></div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="fnb-search h-12 max-w-2xl mx-auto shadow-md">
        <Search size={16} className="ml-4 shrink-0" style={{ color: 'var(--text-3)' }} />
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Tìm nguyên liệu, nhà cung cấp..."
               className="flex-1 px-3 text-sm bg-transparent outline-none" style={{ color: 'var(--text-1)' }} />
        <button className="px-5 h-full text-sm font-semibold text-white shrink-0 rounded-r-lg"
                style={{ background: '#2563eb' }}>Tìm kiếm</button>
      </div>

      {/* Categories */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Danh mục nguyên liệu</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {CATEGORIES.map(cat => (
            <div key={cat.name} className="fnb-card p-4 cursor-pointer text-center">
              <span className="text-3xl mb-2 block">{cat.icon}</span>
              <p className="font-semibold text-sm mb-0.5" style={{ color: 'var(--text-1)' }}>{cat.name}</p>
              <p className="text-[11px]" style={{ color: 'var(--text-3)' }}>{cat.count} sản phẩm</p>
              <span className="inline-block mt-1.5 text-[10px] px-2 py-0.5 rounded-full"
                    style={{ background: '#dbeafe', color: '#2563eb' }}>{cat.tag}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Top suppliers */}
      <div>
        <h2 className="font-display font-bold text-xl mb-5" style={{ color: 'var(--text-1)' }}>Nhà cung cấp nổi bật</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {SUPPLIERS.map(s => (
            <div key={s.name} className="fnb-card p-5 flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center text-xl shrink-0"
                   style={{ background: '#dbeafe' }}>🏭</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <p className="font-semibold text-sm" style={{ color: 'var(--text-1)' }}>{s.name}</p>
                  <span className="text-[10px] px-2 py-0.5 rounded-full shrink-0"
                        style={{ background: '#dbeafe', color: '#2563eb' }}>{s.badge}</span>
                </div>
                <p className="text-xs mt-0.5 mb-2" style={{ color: 'var(--text-3)' }}>{s.products}</p>
                <div className="flex items-center gap-3 text-[11px]" style={{ color: 'var(--text-3)' }}>
                  <span className="flex items-center gap-0.5 text-amber-500 font-semibold">
                    <Star size={10} fill="currentColor" /> {s.rating}
                  </span>
                  <span>{s.orders} đơn hàng</span>
                </div>
              </div>
              <button className="shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold text-white"
                      style={{ background: '#2563eb' }}>Xem</button>
            </div>
          ))}
        </div>
      </div>

      {/* Benefits */}
      <div className="grid sm:grid-cols-3 gap-4">
        {[
          { icon: <Truck size={20}/>, title: 'Giao hàng 2h', desc: 'Giao hàng nội thành trong vòng 2 tiếng', color: '#dbeafe', textColor: '#2563eb' },
          { icon: <Package size={20}/>, title: 'Đặt hàng bulk', desc: 'Chiết khấu lên đến 20% cho đơn hàng số lượng lớn', color: '#dcfce7', textColor: '#16a34a' },
          { icon: <Star size={20}/>, title: 'Cam kết chất lượng', desc: 'Đổi trả miễn phí nếu không đúng chất lượng cam kết', color: '#fef3c7', textColor: '#d97706' },
        ].map(b => (
          <div key={b.title} className="fnb-card p-5 text-center">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3"
                 style={{ background: b.color, color: b.textColor }}>{b.icon}</div>
            <p className="font-bold text-sm mb-1" style={{ color: 'var(--text-1)' }}>{b.title}</p>
            <p className="text-xs" style={{ color: 'var(--text-3)' }}>{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
